import { makeQueryOptions } from '@mint-lib/api-zod-support/react-query';

import { defaultApi } from '@mint-sdk/api-core';

import { CampaignSchema, CampaignTitleSchema } from './schemas.js';

export const getCampaign = defaultApi.declareEndpoint({
  url: 'datintell/v1/campaign_collections/$campaignId/' as const,
  method: 'GET',
  responseSchema: CampaignSchema,
});

export const getCampaignQueryOptions = makeQueryOptions(getCampaign, {
  processResponse(data) {
    return data;
  },
});

export const getCampaignTitle = defaultApi.declareEndpoint({
  url: 'datintell/v1/campaign_collections/$campaignId/title/' as const,
  method: 'GET',
  responseSchema: CampaignTitleSchema,
});

export const getCampaignTitleQueryOptions = makeQueryOptions(getCampaignTitle, {
  processResponse(data) {
    return data;
  },
});
